import { useState } from 'react'
import { createModel } from 'hox'
import { TablePaginationConfig } from 'antd/es/table/interface'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from '@/utils/constants'
import {
    IAssetsArchivesDetail,
    IAssetsArchivesSearchFields,
    assetsArchivesService,
} from './assetsArchivesService'
import { transPgToPagination } from '@/model/globalModel'
import { ISearchPage } from '@/types/AppTypes'
import { ModeType } from '@/model/navModel'
import { globalPrompt } from '@/components/message'



export const assetsArchivesModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IAssetsArchivesDetail[]>([])
    //查询条件
    const [searchParam, setSearchParam] = useState<IAssetsArchivesSearchFields>({})
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    //选择列表的单条信息
    const [selectedRowKeys, setSelectedRowKeys] = useState<IAssetsArchivesDetail>({})
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAssetsArchivesSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await assetsArchivesService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: IAssetsArchivesSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        setSelectedRowKeys({})
        loadData(initPgCfg, {})
    }

    const initAddFormVal = {}
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<any>(initAddFormVal)
    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<any>({})



    return {
        /***field***/
        editFormVal,
        addFormVal,
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        setEditFormVal
    }
})
